import axios from "axios";

const api = axios.create({
  baseURL: "https://ims.heliosedu.in/api",
});

// Request interceptor — attach JWT token + active entity on every call
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Send active entity so backend filters data correctly
    try {
      const activeBranch = JSON.parse(localStorage.getItem("activeBranch"));
      if (activeBranch && activeBranch.id) {
        config.headers["X-Branch-Id"] = activeBranch.id;
      }
    } catch (e) {
      // ignore
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
